// extracted by mini-css-extract-plugin
export default {"menuBlock":"uE-z","title":"vE-z","nav":"wE-z","flexCell":"xE-z","facetLink":"yE-z"};